import { render, staticRenderFns } from "./sportappointcalDetail.vue?vue&type=template&id=3db11bc9&scoped=true"
import script from "./sportappointcalDetail.vue?vue&type=script&lang=js"
export * from "./sportappointcalDetail.vue?vue&type=script&lang=js"
import style0 from "./sportappointcalDetail.vue?vue&type=style&index=0&id=3db11bc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db11bc9",
  null
  
)

export default component.exports